import { Route, Routes } from "react-router-dom";
import BookingPage from "./pages/BookingPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import AdminRedirectPage from "./pages/AdminRedirectPage.jsx";
import OrgCreatePage from "./pages/OrgCreatePage.jsx";
import OrgDashboard from "./pages/OrgDashboard.jsx";
import AdminCreatePage from "./pages/AdminCreatePage.jsx";
import ShopCreatePage from "./pages/ShopCreatePage.jsx";
import ShopConfigPage from "./pages/ShopConfigPage.jsx";
import HairdresserFormPage from "./pages/HairdresserFormPage.jsx";
import LandingPage from "./pages/LandingPage.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/admin" element={<AdminRedirectPage />} />
        <Route path="/admin/orgs/new" element={<OrgCreatePage />} />
        <Route path="/admin/:orgSlug" element={<OrgDashboard />} />
        <Route path="/admin/:orgSlug/admins/new" element={<AdminCreatePage />} />
        <Route path="/admin/:orgSlug/shops/new" element={<ShopCreatePage />} />
        <Route path="/admin/:orgSlug/shops/:shopId" element={<ShopConfigPage />} />
        <Route path="/admin/:orgSlug/shops/:shopId/hairdressers/new" element={<HairdresserFormPage />} />
        <Route path="/admin/:orgSlug/shops/:shopId/hairdressers/:hairdresserId" element={<HairdresserFormPage />} />
      </Route>
      <Route path="/:orgSlug/*" element={<BookingPage />} />
    </Routes>
  );
}
